import { render, staticRenderFns } from "./structured_report_form.vue?vue&type=template&id=795275d0"
import script from "./structured_report_form.vue?vue&type=script&lang=js"
export * from "./structured_report_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports